
<a :href='link' target='_blank'>
  {{ text }}
  <i class='fa fa-external-link'/>
</a>
